import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { AppLocalStorage } from "../../../app-storage-manager/local-storage"

@Injectable({
    providedIn: 'root'
})

export class AuthGuardService implements CanActivate {
    constructor(private router: Router, private storeManager: AppLocalStorage) {}

    canActivate(): boolean {
        if (!this.storeManager.isStoredInSession('xs_access_token')) {
            this.router.navigate(['/auth'])
            return false
        } else { return true; }
    }
}
